import { em } from 'polished'
import styled from 'styled-components'

export const APP_CONTENT_PADDING = em(20)

interface IAppContentStyledProps {
  isSheetOpen?: boolean
}

export const AppContentStyled = styled.div<IAppContentStyledProps>`
  position: relative;
  grid-area: content;
  background-color: ${(props) => props.theme.colors.offwhite};
  padding: ${APP_CONTENT_PADDING};
  padding-right: ${(props) =>
    props.isSheetOpen ? em(420) : APP_CONTENT_PADDING};

  @media print {
    position: absolute;
    width: 100%;
  }
`
